import type * as Stitches from '@stitches/react'

import { Icon } from '../icon'
import type { IconNames } from '../icon'
import { StyledIcon } from '../icon/icon.styles'
import { StyledIconButton } from './icon-button.styles'

export type IconButtonProps = {
  action: () => void
  iconName: IconNames
  isActive?: boolean
  isDisabled?: boolean
  size?: Stitches.VariantProps<typeof StyledIcon>['size']
  title: string
}

export const IconButton = ({
  action,
  iconName,
  isActive = false,
  isDisabled = false,
  size = 'small',
  title
}: IconButtonProps) => {
  return (
    <StyledIconButton
      aria-label={title}
      isActive={isActive}
      isDisabled={isDisabled}
      disabled={isDisabled}
      onClick={action}
      size={size}
      title={title}
    >
      <Icon name={iconName} size={size === 'small' ? 'small' : 'medium'} />
    </StyledIconButton>
  )
}
